/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Processing_SubtitleInputs */

const vi_tea_purchase_processing_subtitle = /** @type {(inputs: Tea_Purchase_Processing_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật khối lượng chè khô thu được sau sản xuất cho các đơn chè tươi.`)
};

/**

* @param {Tea_Purchase_Processing_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_processing_subtitle = /** @type {((inputs?: Tea_Purchase_Processing_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Processing_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_processing_subtitle(inputs)
});